import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NOTIFICATION_SERVICE, RentigoNgxCommonModule } from '@rentigo/ngx-common';
import { AuthInterceptorService, PolicyRegistration, RentigoNgxAuthorizationModule } from '@rentigo/ngx-authorization';
import { DashboardNotificationService } from '../shared/notification/notification.service';
import { InitializationService } from '../shared/initilization/initialization.service';
import { Claims, Policies } from '../shared/shared.model';

@NgModule({
  imports: [
    HttpClientModule,
    RentigoNgxCommonModule.forRoot(),
    RentigoNgxAuthorizationModule.forRoot({
      loginUrl: '/login',
      returnUrl: 'security-deposit',
      policies: [
        { policy: Policies.AUTHENTICATE },
        PolicyRegistration.claimsPolicy(Policies.INVITES, [Claims.INVITES]),
        PolicyRegistration.claimsPolicy(Policies.APPLICATIONS, [Claims.APPLICATIONS]),
        PolicyRegistration.claimsPolicy(Policies.TENANTS, [Claims.TENANTS]),
        PolicyRegistration.claimsPolicy(Policies.CLAIMS, [Claims.CLAIMS]),
        PolicyRegistration.claimsPolicy(Policies.PROPERTIES, [Claims.PROPERTIES]),
        PolicyRegistration.claimsPolicy(Policies.FINANCES, [Claims.FINANCES]),
        PolicyRegistration.claimsPolicy(Policies.MANAGERS, [Claims.MANAGERS]),
        PolicyRegistration.claimsPolicy(Policies.TECH, [Claims.TECH]),
        PolicyRegistration.claimsPolicy(Policies.RANKINGS, [Claims.RANKINGS])
      ]
    })
  ],
  declarations: [],
  providers: [
    { provide: NOTIFICATION_SERVICE, useClass: DashboardNotificationService },
    {
      provide: APP_INITIALIZER,
      useFactory: (initializationService: InitializationService) => () => initializationService.initialize(),
      deps: [InitializationService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    }
  ],
  exports: []
})
export class CoreModule { }
